import { trpc } from '@/shared/api';

/** 상품 상세 조회 — 에디터 수정 화면의 기준 데이터. */
export const useProductDetailQuery = (id: string) =>
  trpc.productManagement.products.get.useQuery({ id });
